import { Heading as ChakraHeading } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type HeadingProps = ComponentPropsWithRef<typeof ChakraHeading>;

export function Heading(props: HeadingProps) {
  return <ChakraHeading {...props} />;
}
